import { render, staticRenderFns } from "./Destaques.vue?vue&type=template&id=ab9439ac&"
import script from "./Destaques.vue?vue&type=script&lang=js&"
export * from "./Destaques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports